import BasicSlider from './BasicSlider';
import FrontpageSlider from './FrontpageSlider';

const componentStore = [];

document.querySelectorAll('.slider').forEach(($slider) => {
  const config = {
    autoplay: $slider.getAttribute('data-autoplay') === 'true',
    hasArrows: $slider.getAttribute('data-arrows') === 'true',
    hasDots: $slider.getAttribute('data-dots') === 'true',
    hasCount: $slider.getAttribute('data-count') === 'true',
    hasPagination: $slider.getAttribute('data-pagination') === 'true',
    verticalImages: true,
    autoplayTime: $slider.getAttribute('data-autoplay-time'),
  };

  if ($slider.classList.contains('slider--frontpage')) {
    config.verticalImages = false;
    componentStore.push(new FrontpageSlider($slider, config));
  } else {
    componentStore.push(new BasicSlider($slider, config));
  }
});
